import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadQidDatapoints,
    DeleteQidModel,
    setQidModelDeleteModel,
    setQidModelReloadList,
    setQidDatapointReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
    Loader,
} from "client/components"


export const ConfirmDeleteModel = () => {
    const product = useSelector((state: StoreType) => state.qidProduct.productView)
    const model = useSelector((state: StoreType) => state.qidModel.deleteModel)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [datapoints, setDatapoints] = useState<number>(0)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!model) return
        setLoadState(PENDING)
        LoadQidDatapoints({
            modelId: model.id,
        }).then((res) => {
            setDatapoints(res.length)
            setLoadState(IDLE)
        })
    }, [model])

    const onCancel = () => {
        dispatch(setQidModelDeleteModel(null))
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        DeleteQidModel(model.id, product.id).then(() => {
            setDeleteState(IDLE)

            dispatch(setQidModelDeleteModel(null))

            dispatch(setQidModelReloadList(false))
            dispatch(setQidDatapointReloadList(false))
            setTimeout(() => {
                dispatch(setQidModelReloadList(true))
                dispatch(setQidDatapointReloadList(true))
            }, 0)
        })
    }

    return (
        <ConfirmWrapper show={!!model} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{model ? model.name : ""}</ConfirmTitle>
                <ConfirmDescription>
                    {
                        loadState === PENDING
                            ? <Loader />
                            : (datapoints > 0 ? lang.deleteModelDatapointsConfirm : lang.deleteModelConfirm)
                    }
                </ConfirmDescription>

                <ConfirmBottom>
                    <Button variant="success" row disabled={deleteState === PENDING} onClick={onConfirmDelete}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeleteModel
